import request from '../../../Helpers/Request';

class Pricing {
    constructor(settings) {
        this.settings = settings;
    }

    index(connectionId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/pricing`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    show(connectionId, pricingId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/pricing/${pricingId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    store(connectionId, data) {
        return new Promise((resolve, reject) => {
            request('POST', `/clients/connections/${connectionId}/pricing`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(connectionId, pricingId, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${connectionId}/pricing/${pricingId}`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    destroy(connectionId, pricingId) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/clients/connections/${connectionId}/pricing/${pricingId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Pricing;
